
import { defineComponent } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '@/assets/util'

export default defineComponent({
  props: {
    eventDate: { type: Date, required: false, default: undefined },
    title: { type: String, required: false, default: undefined },
    url: { type: String, required: false, default: undefined },
    streamUrl: { type: String, required: false, default: undefined },
    tixSaleIsAvailable: { type: Boolean, required: false, default: undefined },
    concertState: { type: Object, required: false, default: undefined },
    theme: { type: String, required: false, default: undefined },
  },
  setup(props, { emit }) {
    return {
      orderClick: () => emit('orderClick'),
      ...setupTranslationPrefixer('event-detail'),
    }
  },
})
